import store from '@/store'

const routeRole = {
  pagrindinis: null,
  ntSandoris: ['nera'],
  hipoteka: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
    'DT_teismas',
    'DT_antstolis',
    'DT_kita_institucija',
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  sutartis: [
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  prasymasNaujas: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
  rengiamiDokumentaiTab: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
    'DT_teismas',
    'DT_antstolis',
    'DT_kita_institucija',
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  rengiamiDokumentaiHipoteka: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
    'DT_teismas',
    'DT_antstolis',
    'DT_kita_institucija',
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  rengiamiDokumentaiPrasymas: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
  ],
  perduotiDokumentaiTab: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
    'DT_teismas',
    'DT_antstolis',
    'DT_kita_institucija',
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
  ],
  perduotiDokumentaiHipoteka: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
    'DT_teismas',
    'DT_antstolis',
    'DT_kita_institucija',
    'DT_JA',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
  ],
  perduotiDokumentaiPrasymas: [
    'DT_notaras',
    'DT_notaro_padejejas',
    'DT_notaro_atstovas',
  ],

  zurnalastab: [
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
    'SK_skaitytojas',
  ],
  zurnalasGaunami: [
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
    'SK_skaitytojas',
  ],
  zurnalasNtrGaunami: ['RG_NTR_registrat', 'RG_NTR_vadovas', 'SK_skaitytojas'],
  zurnalasSiunciami: [
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  regitraPranesimai: [
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],
  teikejasRengiami: ['RG_STSR_registrat', 'RG_NTR_registrat', 'RG_NTR_vadovas'],

  paieskaTab: [
    'P_S_pagal_JA',
    'P_S_pagal_FA',
    'P_S_pagal_turta',
    'P_I_pagal_ID',
    'P_IA_pagal_ID',
    'P_IT_pagal_ID',
    'P_IAT_pagal_ID',
    'P_TZ_pagal_JA',
    'P_TZ_pagal_FA',
    'P_TZ_pagal_turta',
    'KAC_darbuotojas',
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
    'ntr3.reg',
  ],
  paieskaJuridinis: ['P_S_pagal_JA', 'P_TZ_pagal_JA'],
  paieskaFizinis: ['P_S_pagal_FA', 'P_TZ_pagal_FA'],
  paieskaTurtas: ['P_S_pagal_turta', 'P_TZ_pagal_turta', 'ntr3.reg'],
  paieskaKodas: [
    'P_I_pagal_ID',
    'P_IA_pagal_ID',
    'P_IT_pagal_ID',
    'P_IAT_pagal_ID',
  ],
  paieskaMano: [
    'P_S_pagal_JA',
    'P_S_pagal_FA',
    'P_S_pagal_turta',
    'P_I_pagal_ID',
    'P_IA_pagal_ID',
    'P_IT_pagal_ID',
    'P_IAT_pagal_ID',
    'P_TZ_pagal_JA',
    'P_TZ_pagal_FA',
    'P_TZ_pagal_turta',
  ],
  paieskaTvirtinimas: ['KAC_darbuotojas'],
  paieskaRegistruoti: [
    'RG_STSR_registrat',
    'RG_NTR_registrat',
    'RG_NTR_vadovas',
  ],

  savPaieskaTab: ['EL_FA', 'EL_JA'],
  savPaieskaMano: ['EL_FA', 'EL_JA'],
  savPaieskaJuridinis: ['EL_FA', 'EL_JA'],
  savPaieskaFizinis: ['EL_FA', 'EL_JA'],
  savPaieskaTurtas: ['EL_FA', 'EL_JA'],
  savPaieskaKodas: ['EL_FA', 'EL_JA'],

  archyvoNaikinimas: ['AR_archyvatorius', 'AD_administratorius'],
  naikinimasFormavimas: ['AR_archyvatorius', 'AD_administratorius'],
  naikinimasAktas: ['AR_archyvatorius', 'AD_administratorius'],
  naikinimasArchyvaras: ['AR_archyvatorius', 'AD_administratorius'],

  administravimas: ['AD_administratorius'],
  adminParametrai: ['AD_administratorius'],
  adminKlasifikatoriai: ['AD_administratorius'],
  adminTeises: ['AD_administratorius'],
  adminRegistrai: ['AD_administratorius'],
  adminRegistravimasAutomatu: ['AD_administratorius'],
  adminTaisykles: ['AD_administratorius'],
  adminTooltip: ['AD_administratorius'],
  adminSiuntimoAdministravimas: ['AD_administratorius'],
  adminAtaskaita: ['AD_administratorius'],
  adminBroker: ['AD_administratorius'],
  adminBrokerList: ['AD_administratorius'],
  adminSistemaInfo: ['AD_administratorius'],
  adminZinute: ['AD_administratorius'],
  adminGeneravimas: ['AD_administratorius'],
  adminPasTvarkymas: ['AD_administratorius'],
}

export function getRouteRole(routeName) {
  return routeRole[routeName]
}
export function authRoute(routeName) {
  const userRole = store.getters.userRole
  const checkRole = getRouteRole(routeName)
  if (!checkRole) {
    return true
  }
  return checkRole.some(item => {
    return userRole.includes(item)
  })
}
